module.exports = __webpack_public_path__ + "static/media/16.00d31515.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/16.jpg
// module id = 706
// module chunks = 0